const FALLBACK_CLASS = 'is-video-fallback';

function getTeaserImage(video: HTMLVideoElement): HTMLElement | null {
  const videoWrapper = video.closest('.cmp-teaser__video');
  if (!videoWrapper?.parentElement) return null;

  return videoWrapper.parentElement.querySelector(':scope > .cmp-teaser__image');
}

function showTeaserImageFallback(video: HTMLVideoElement): void {
  const teaser = video.closest('.cmp-teaser--has-video');
  if (!teaser || !getTeaserImage(video)) return;

  video.pause();
  video.controls = false;
  video.removeAttribute('controls');
  teaser.classList.add(FALLBACK_CLASS);
}

function hasAutoplay(video: HTMLVideoElement): boolean {
  const attr = video.getAttribute('autoplay');
  if (attr === null) return false;
  return attr !== 'false' && attr !== '0';
}

function setupTeaserVideo(video: HTMLVideoElement): void {
  if (video.dataset['fallbackSetup'] === 'true') return;
  video.dataset['fallbackSetup'] = 'true';

  video.addEventListener('error', () => showTeaserImageFallback(video), { once: true });

  if (video.error) {
    showTeaserImageFallback(video);
    return;
  }

  if (!hasAutoplay(video)) return;

  void video.play().catch(() => showTeaserImageFallback(video));

  const timeoutId = window.setTimeout(() => {
    if (teaserHasFallback(video) || !video.paused) return;
    showTeaserImageFallback(video);
  }, 1500);

  video.addEventListener('playing', () => window.clearTimeout(timeoutId), { once: true });
}

function teaserHasFallback(video: HTMLVideoElement): boolean {
  return !!video.closest(`.${FALLBACK_CLASS}`);
}

function initTeaserVideos(): void {
  document
    .querySelectorAll<HTMLVideoElement>('.cmp-teaser--has-video .cmp-videoteaser__video--video')
    .forEach(setupTeaserVideo);
}

if (document.readyState !== 'loading') {
  initTeaserVideos();
} else {
  document.addEventListener('DOMContentLoaded', initTeaserVideos);
}
